// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tijAPCa4{position:relative}.VaJY9gWa{top:80px;width:230px}`, "",{"version":3,"sources":["webpack://./src/fsd/shared/ui/filter-panel/components/MonthRangeField/MonthRangeField.module.scss"],"names":[],"mappings":"AAEA,UACE,iBAAA,CAGF,UACE,QAAA,CACA,WAAA","sourcesContent":["@use '@fsd/shared/ui/temp_style/__colors.scss' as *;\n\n.pickerWrapper {\n  position: relative;\n}\n\n.options {\n  top: 80px;\n  width: 230px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pickerWrapper": `tijAPCa4`,
	"options": `VaJY9gWa`
};
export default ___CSS_LOADER_EXPORT___;
